import React from 'react'

import styled from 'styled-components'

const Container = styled.div`
    width: 100%;
    height: 50vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    border: 1px solid #aaaaaa;
`

const Image = styled.img`
    width: 80%;
    height: 80%;
    object-fit: contain;
`

const Ime = styled.h1`
    font-size: 18px;
    text-align: center;
    font-family: 'Poppins', sans-serif;
    font-weight: 400;
`

const HPItem = ({ item }) => {
  return (
    <Container>
        <Image src={item.slika} />
        <Ime>{item.ime}</Ime>
    </Container>
  )
}

export default HPItem